<style lang="less" scoped>
.home-main {
  background: #eeeeee;
  .to-top-btn {
    height: 49px;
    width: 49px;
    position: fixed;
    bottom: 54px;
    right: 10px;
    z-index: 6;
  }
  .license {
    overflow: hidden;
    margin-top: 10px;
  }
}
</style>
<template>
  <div class="home-main">
    <billboards
      :bannerHeight="GET_bannerHeight_16_9_Fun"
      :swipeAuto="swipeAuto"
      ref="billboard"
      :billboardList="billboardList"
      @click-banner="clickBanner"
    ></billboards>
    <recommend
      :recommendList="recommendList"
      imgWidth="44"
      @click-icon="clickRecomend"
    ></recommend>
    <banner></banner>
    <topic-list></topic-list>
    <popular>
      <div class="license" @click="toLicense">
        <lazy-img
          class=""
          :src="licenseBanner"
          width="100%"
          height="26.7vw"
        ></lazy-img>
      </div>
    </popular>
    <act-tip></act-tip>
    <act-float-layer></act-float-layer>
    <to-top-btn></to-top-btn>
  </div>
</template>
<script>
import { imgFormats } from "@roots/pLibrary/javascriptTool.js";
const { GET_bannerHeight_16_9 } = imgFormats;
import actFloatLayer from "../../act/home_float_layer";
import billboards from "../../../components/billboards";
import recommend from "../../../components/recommend";
import banner from "./banner.vue";
import popular from "./popular.vue";
import actTip from "../../../components/home-act-tip.vue";
import topicList from "./topic_list";
import { resolveActionPath, getHostName } from "../../../util/function";
import toTopBtn from "../../../components/to-top-btn";
import { trackData } from "../../../directives/track.js";
import lazyImg from "../../../components/lazy-img.vue";
import { ACTIONTYPE_DM } from "@src/tools/consts/constsThird";

export default {
  props: ["swipeAuto"],
  data() {
    return {
      ACTIONTYPE_DM,
      doc: document.documentElement,
      licenseBanner: require("../../../../image/home/license-banner.png")
    };
  },
  components: {
    billboards,
    recommend,
    banner,
    topicList,
    popular,
    toTopBtn,
    lazyImg,
    "act-tip": actTip,
    "act-float-layer": actFloatLayer
  },
  methods: {
    clickBanner(bannerId) {
      console.log(bannerId, "-bannerId-");
      // trackData({ id: 304, p: [bannerId] });
      // trackData({ id: 3001, p: [bannerId] });
    },
    clickRecomend(id) {
      console.log(id, "--id----");
      // trackData({ id: 305, p: [id] });
    },
    toLicense() {
      location.href = getHostName() + "/act/active/RvuwzG287345";
    }
  },
  computed: {
    GET_bannerHeight_16_9_Fun() {
      return `${String(GET_bannerHeight_16_9())}px`;
    },
    billboardList() {
      return this.$store.state.home.billboardList.map(item => {
        let _href = resolveActionPath(item);
        return {
          actionData:item.actionData,
          actionType: item.actionType,
          id: item.bannerId,
          href: _href,
          imgUrl: item.imgUrl
        };
      });
    },
    recommendList() {
      return this.$store.state.home.recommendList.map(item => {
        return {
          id: item.bannerId,
          href: resolveActionPath(item),
          title: item.masterTitle,
          imgUrl: item.imgUrl
        };
      });
    }
  },
  mounted() {
    this.$store.dispatch("getBillboards").catch(e => console.log(e));
    this.$store.dispatch("getBanner").catch(e => console.log(e));

    this.$nextTick(() => {
      this.$store.dispatch("getHomeRecommend").catch(e => console.log(e));
      this.$store.dispatch("getHomeFloatBanner").catch(e => console.log(e));
      this.$store.dispatch("getHomeActStatus").catch(e => console.log(e));
    });
  }
};
</script>
